import PropTypes from 'prop-types'
import React from 'react'
import KanBoIcon from 'components/KanBoIcon'
import {
  ToggleModal
} from 'components/Modal'
import styled from 'styled-components'

const InfoIcon = styled.span`
  cursor: pointer;
  font-size: 16px;
  line-height: 1em;
  color: #999;

  &:hover {
    color: #000;
  }
`

const Modal = styled.div`
  max-width: 400px;
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
  word-wrap: break-word;
`

const Info = ({ children, ...props }) => {
  return (
    <ToggleModal
      backdrop
    >
      <InfoIcon {...props}>
        <KanBoIcon
          name='kanbo-16-info'
        />
      </InfoIcon>
      <Modal>
        {children}
      </Modal>
    </ToggleModal>
  )
}

Info.propTypes = {
  className: PropTypes.string
}

export default Info
